import apiClient from '../apiClient';
import { GET_ACCOMODATION_ITEM_BYPROFILE_ID_URL } from '../apiUrl';

const getAccomodationItemByProfileIdApi = Id => {
  return apiClient.get(GET_ACCOMODATION_ITEM_BYPROFILE_ID_URL(Id));
};

export default getAccomodationItemByProfileIdApi;
